module.exports = __webpack_public_path__ + "static/media/mall-category-10.2ac72f4d.png";